import React from 'react';
import { FadeIn, CtaButton } from './Shared';
export const HeroSection = () => {
  return <section className="bg-brand-cream pt-10 pb-14 md:pt-14 md:pb-20 px-6 relative overflow-hidden" data-id="element-127">
      {/* Subtle decorative background element */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 opacity-10 pointer-events-none" data-id="element-128">
        <svg width="400" height="400" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-129">
          <path fill="#5B8E7D" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,81.3,-46.3C90.8,-33.5,96.8,-18.1,97.1,-2.6C97.4,12.9,92,28.5,82.4,41.3C72.8,54.1,59,64.1,44.2,71.4C29.4,78.7,13.6,83.3,-1.8,86.4C-17.2,89.5,-32.4,91.1,-45.4,85.2C-58.4,79.3,-69.2,65.9,-77.3,51.3C-85.4,36.7,-90.8,20.9,-91.1,5.1C-91.4,-10.7,-86.6,-26.5,-78.2,-40.4C-69.8,-54.3,-57.8,-66.3,-43.9,-73.7C-30,-81.1,-14.2,-83.9,1.1,-85.8C16.4,-87.7,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" data-id="element-130" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-131">
        <FadeIn data-id="element-132">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-brand-charcoal" data-id="element-133">
            Adiós a la Inflamación y la Fatiga en 14 Días
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-134">
          <p className="text-lg md:text-xl mb-6 text-gray-700 font-medium" data-id="element-135">
            Sin dietas extremas, sin pastillas costosas y sin matarte en el
            gimnasio.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-136">
          <p className="text-base md:text-lg mb-8 text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-137">
            Descubre el Protocolo de Drenaje y Recarga (D-R) que está ayudando a
            mujeres a recuperar su vientre plano, su energía natural y su
            claridad mental… empezando desde su hígado.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} className="flex justify-center mb-8" data-id="element-138">
          <div className="relative w-full max-w-sm" data-id="element-139">
            <div className="absolute inset-0 bg-brand-teal rounded-3xl transform rotate-3 opacity-20" data-id="element-140"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jD6ooqAftkkWsDasxGYure/Higado_-_14_dias_.png" alt="Hígado Vital - Protocolo de 14 días" className="relative z-10 rounded-2xl shadow-2xl w-full object-cover aspect-[4/5]" data-id="element-141" />
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-142">
          <CtaButton data-id="element-143">👉 COMENZAR AHORA</CtaButton>
        </FadeIn>
      </div>
    </section>;
};